import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import editImg from '../../../assets/images/edit.svg';
import Helper from '../../helper';
import Application from '../../services/application.service';

const Review = (props) => {
    let input = props.input

    const navigate = useNavigate();
    const [streetAdd, setStreetAdd] = useState({});
    const [postalAdd, setPostalAdd] = useState({});

    const Ids = { "P": "Passport", "I": "ID" };
    const accountType = { "S": "Saving", "F": "Fixed", "SA": "Salary" };
    let statusArr = { L: 'Lead', P: 'Pending', OHAD: 'On Hold - Awaiting Docs', OHACF: 'On Hold - Awaiting Client Feedback', S: 'Submitted', AC: 'Account Opened', C: 'Closed' };
    const gender = { "M": "Male", "F": "Female", "O": "Other" };
    const paymentMethod = { "C": "Cheque Deposit", "I": "Electronic/Internet Transfer", "E": "Electronic Collection", "R": "Regular Debit Order" };

    useMemo(() => {
        if (input.status) {
            setStreetAdd({ address_1: input.address_1, address_2: input.address_2, suburb: input.suburb, city: input.city, postal_code: input.postal_code, country: input.country })

            setPostalAdd({ address_1: input.postal_address_1, address_2: input.postal_address_2, suburb: input.postal_suburb, city: input.postal_city, postal_code: input.postal_postal_code, country: input.postal_country })
        }
    }, [input]);

    const handleSubmit = e => {
        e.preventDefault();

        var dt = { ...input };
        dt.lump_sum_amount = input.debit_order;
        dt.month_debit_amount = input.amount;
        dt.source_fund_invested = input.source_of_fund;
        dt.other_fund_invested = input.other_fund_source;
        dt.domenstic_prominent = input.is_domenstic_prominent || 0;
        dt.domenstic_details = input.domenstic_details;
        dt.tax = input.tax_details;
        dt.is_cheque_agree = input.is_cheque_agree == 'Y' ? 1 : '';

        var formData = Helper.convertFormData(dt);
        formData.append('is_user', 1);

        Application.Submit(formData).then(res => {
            if (res.success === true) {
                Helper.success(res.message);
                navigate('/thankyou');
            } else {
                Helper.reviewError(res);
            }
        }).catch(err => console.log(err));
    }

    return (
        props.isLoading ? Helper.ShowLoader() :
            <>
                <div className="form-wrapper">
                    <div className='form-head'>
                        {(input.status == 'P' || input.status == 'L') ? <h2>Review Your Details </h2> : <h2>Review Your Details - {statusArr[input.status]} </h2>}
                    </div>
                    <div className="form-fields p-0">
                        <div className="application-details-wrapper">
                            <div className="form-section division-border p-0 pt-5">
                                <div className="d-flex align-items-center mb-4">
                                    <h4 className="m-0">Personal Details</h4>
                                    {(input.status == 'P' || input.status == 'L') &&
                                        <span className="px-1" >
                                            <a onClick={() => props.setFormCount(1)} className="btn p-0 ml-1"><img src={editImg} height={22} /></a>
                                        </span>
                                    }
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 field-wrapper id_number id_type">
                                        <div className="label">ID Number</div>
                                        <div className="value">{Ids[input.id_type]} - {input.id_number}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper first_name last_name">
                                        <div className="label">Full Name</div>
                                        <div className="value">{input.first_name} {input.last_name}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper email">
                                        <div className="label">Email Address</div>
                                        <div className="value">{input.email ?? '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper phone">
                                        <div className="label">Telephone Number (Home/Work/Cell)</div>
                                        <div className="value">{input.phone ?? '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper gender">
                                        <div className="label">Gender</div>
                                        <div className="value">{gender[input.gender] ?? '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper dob">
                                        <div className="label">Date of Birth</div>
                                        <div className="value">{input.dob ? Helper.dateFormat(input.dob, 'dd/MM/yyyy') : '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper nationality">
                                        <div className="label">Nationality</div>
                                        <div className="value">{input.nationality ?? '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper matrial_status">
                                        <div className="label">Marital Status</div>
                                        <div className="value">{input.matrial_status ?? '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper country_of_residence">
                                        <div className="label">Country of Residence</div>
                                        <div className="value">{input.country_of_residence ?? '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 field-wrapper occupation">
                                        <div className="label">Occupation</div>
                                        <div className="value">{input.occupation ?? '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                </div>
                                <h5 className='sub-heading'>Address Details</h5>
                                <div className="row">
                                    <div className="col-12 field-wrapper street_address">
                                        <div className="label">Street Address</div>
                                        <div className="value">{Helper.checkProperties(streetAdd) === false ? Helper.objJoin(streetAdd) : '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    <div className="col-12 field-wrapper postal_address">
                                        <div className="label">Postal Address</div>
                                        <div className="value">{Helper.checkProperties(postalAdd) === false ? Helper.objJoin(postalAdd) : '-'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                </div>
                                <h5 className='sub-heading'>Tax Details</h5>
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 field-wrapper is_tax_number">
                                        <div className="label">Do you have a Tax Number?</div>
                                        <div className="value">{input.is_tax_number == 'Y' ? 'Yes' : 'No'}</div>
                                        <div className='validationAlert'></div>
                                    </div>
                                    {input.is_tax_number === 'Y' &&
                                        <div className="col-lg-6 col-md-12 field-wrapper income_tax_number">
                                            <div className="label">Income Tax Number</div>
                                            <div className="value">{input.income_tax_number ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                    }
                                    {input.is_tax_number === 'N' &&
                                        <div className="col-lg-6 col-md-12 field-wrapper tax_refernce_number">
                                            <div className="label">Tax Reference</div>
                                            <div className="value">{input.tax_refernce_number ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                    }
                                    <div className="col-lg-12 col-md-12">
                                        <div className="sub-section">
                                            <h5 className='sub-heading'>Foreign Tax (if Applicable)</h5>
                                            {input.tax_details.length > 0 ? input.tax_details.map((x, i) => {
                                                return <ForeignTaxRow key={i} arr={x} index={i} />;
                                            }) : '-'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-section division-border p-0 pt-5">
                                <div className="d-flex align-items-center mb-4">
                                    <h4 className="m-0">Investment Details</h4>
                                    {(input.status == 'P' || input.status == 'L') &&
                                        <span className="px-1" >
                                            <a onClick={() => props.setFormCount(4)} className="btn p-0 ml-1"><img src={editImg} height={22} /></a>
                                        </span>
                                    }
                                </div>
                                <div className="sub-section">
                                    <h5 className='sub-heading'>Investment Amount</h5>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 field-wrapper lump_sum_amount">
                                            <div className="label">Lump-Sum Amount</div>
                                            <div className="value">{input.debit_order ? input.debit_order : '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 field-wrapper month_debit_amount">
                                            <div className="label">Monthly Debit Amount</div>
                                            <div className="value">{input.amount ? input.amount : '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 field-wrapper source_fund_invested">
                                            <div className="label">Source of Funds Invested</div>
                                            <div className="value">{input.source_of_fund ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        {input.source_of_fund == 'other' &&
                                            <div className="col-lg-6 col-md-12 field-wrapper other_fund_invested">
                                                <div className="label">Other</div>
                                                <div className="value">{input.other_fund_source ?? '-'}</div>
                                                <div className='validationAlert'></div>
                                            </div>
                                        }
                                        <div className="col-lg-6 col-md-12 field-wrapper domenstic_prominent">
                                            <div className="label">Domestic Prominent</div>
                                            <div className="value">{input.is_domenstic_prominent == 'Y' ? 'Yes' : 'No'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        {input.is_domenstic_prominent == 'Y' &&
                                            <div className="col-lg-6 col-md-12 field-wrapper domenstic_details">
                                                <div className="label">Domestic Details</div>
                                                <div className="value">{input.domenstic_details}</div>
                                                <div className='validationAlert'></div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="form-section division-border p-0">
                                <div className="d-flex align-items-center mb-4">
                                    <h4 className="m-0">Payment Details</h4>
                                    {(input.status == 'P' || input.status == 'L') &&
                                        <span className="px-1">
                                            <a onClick={() => props.setFormCount(5)} className="btn p-0 ml-1"><img src={editImg} height={22} /></a>
                                        </span>
                                    }
                                </div>
                                <div className="sub-section">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 field-wrapper payment_type">
                                            <div className="label">Method of Payment</div>
                                            <div className="value">{paymentMethod[input.payment_type] ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        {input.payment_type == 'C' &&
                                            <div className="col-lg-12 col-md-12 field-wrapper is_cheque_agree">
                                                <div className="label">I / We agree to pay bank charges and costs incurred for any cash deposits made.</div>
                                                <div className="value">{input.is_cheque_agree == 'Y' ? 'Yes' : 'No'}</div>
                                                <div className='validationAlert'></div>
                                            </div>
                                        }
                                    </div>
                                    {input.payment_type == 'R' &&
                                        <div className="row">
                                            <div className="col-lg-6 col-md-12 field-wrapper commencement_date">
                                                <div className="label">Commencement Date</div>
                                                <div className="value">{input.commencement_date ? Helper.dateFormat(input.commencement_date, 'dd/MM/yyyy') : '-'}</div>
                                                <div className='validationAlert'></div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 field-wrapper annual_escalation">
                                                <div className="label">Annual Escalation (%)</div>
                                                <div className="value">{input.annual_escalation + '%' ?? '-'}</div>
                                                <div className='validationAlert'></div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="form-section">
                                <div className="d-flex align-items-center mb-4">
                                    <h4 className="m-0">Bank Details</h4>
                                    {(input.status == 'P' || input.status == 'L') &&
                                        <span className="px-1" >
                                            <a onClick={() => props.setFormCount(6)} className="btn p-0 ml-1"><img src={editImg} height={22} /></a>
                                        </span>
                                    }
                                </div>
                                <div className="sub-section">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 field-wrapper name">
                                            <div className="label">Name of Account Holder</div>
                                            <div className="value">{input.name ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 field-wrapper account_number">
                                            <div className="label">Account Number</div>
                                            <div className="value">{input.account_number ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 field-wrapper bank_name">
                                            <div className="label">Bank</div>
                                            <div className="value">{input.bank_name ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 field-wrapper account_type">
                                            <div className="label">Account Type</div>
                                            <div className="value">{accountType[input.account_type] ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 field-wrapper branch_name">
                                            <div className="label">Branch Name</div>
                                            <div className="value">{input.branch_name ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 field-wrapper branch_code">
                                            <div className="label">Branch Code</div>
                                            <div className="value">{input.branch_code ?? '-'}</div>
                                            <div className='validationAlert'></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(input.status == 'P' || input.status == 'L') &&
                    <div className='form-actions'>
                        <div className='row'>
                            <div className="col-12 pt-4">
                                <div className="button-wrapper">
                                    <button type="button" className="btn btn-ouline" onClick={() => props.setFormCount(6)}>Back</button>
                                    <button type="button" className="btn btn-primary" onClick={handleSubmit}>Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
    )
}

const ForeignTaxRow = props => {
    var arr = props.arr;
    return (
        <div className="row">
            <div className='col-lg-6 col-md-12 field-wrapper' id={`tax.${props.index}.country_issue`}>
                <div className="label">Country of Issue</div>
                <div className="value">{arr.country_issue ?? '-'}</div>
                <div className='validationAlert'></div>
            </div>
            <div className='col-lg-6 col-md-12 field-wrapper' id={`tax.${props.index}.tax_number`}>
                <div className="label">Tax ID Number</div>
                <div className="value">{arr.tax_number.length > 0 ? arr.tax_number : '-'}</div>
                <div className='validationAlert'></div>
            </div>
        </div>
    );
}

export default Review;